'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHoc = require('@mindz/react-hoc');

var _InputFieldDefaultModule = require('./InputField.default.module.css');

var _InputFieldDefaultModule2 = _interopRequireDefault(_InputFieldDefaultModule);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var EyeClosed = function EyeClosed(props) {
  return _react2.default.createElement('svg', props, _react2.default.createElement('g', {
    fill: 'none',
    fillRule: 'evenodd',
    opacity: '.496'
  }, _react2.default.createElement('path', {
    d: 'M14.822 6.397a9.083 9.083 0 0 0-3.15-3.183c-1.318-.802-2.71-1.203-4.177-1.203-1.467 0-2.86.4-4.179 1.203A9.081 9.081 0 0 0 .167 6.397C.056 6.6 0 6.798 0 6.994c0 .197.056.396.167.597a9.079 9.079 0 0 0 3.15 3.184c1.318.802 2.71 1.203 4.178 1.203 1.466 0 2.859-.4 4.177-1.198a9.023 9.023 0 0 0 3.15-3.189c.111-.201.167-.4.167-.597 0-.196-.056-.395-.167-.597zM5.7 4.031c.5-.516 1.097-.774 1.794-.774.112 0 .207.04.285.121.078.08.117.179.117.294a.408.408 0 0 1-.401.415c-.48 0-.89.176-1.23.528-.34.352-.51.776-.51 1.272 0 .116-.04.213-.117.294a.38.38 0 0 1-.285.121.38.38 0 0 1-.284-.12.408.408 0 0 1-.117-.295c0-.72.25-1.34.748-1.856zM11.13 9.82a6.718 6.718 0 0 1-3.634 1.052A6.715 6.715 0 0 1 3.86 9.819c-1.118-.7-2.048-1.642-2.79-2.825.848-1.36 1.91-2.379 3.188-3.054a3.88 3.88 0 0 0-.51 1.947c0 1.067.366 1.98 1.1 2.738.732.759 1.615 1.138 2.647 1.138 1.031 0 1.913-.38 2.647-1.138.733-.758 1.1-1.67 1.1-2.738a3.88 3.88 0 0 0-.51-1.947c1.276.675 2.339 1.693 3.186 3.054-.741 1.183-1.671 2.125-2.79 2.825z',
    fill: '#333',
    fillRule: 'nonzero'
  }), _react2.default.createElement('path', {
    d: 'M13.763.757L1.238 13.282',
    stroke: '#333',
    strokeLinecap: 'round'
  })));
};

EyeClosed.defaultProps = {
  width: '15',
  height: '14',
  viewBox: '0 0 15 14',
  xmlns: 'http://www.w3.org/2000/svg'
};

var EyeOpen = function EyeOpen(props) {
  return _react2.default.createElement('svg', props, _react2.default.createElement('path', {
    d: 'M14.822 6.397a9.083 9.083 0 0 0-3.15-3.183c-1.318-.802-2.71-1.203-4.177-1.203-1.467 0-2.86.4-4.179 1.203A9.081 9.081 0 0 0 .167 6.397C.056 6.6 0 6.798 0 6.994c0 .197.056.396.167.597a9.079 9.079 0 0 0 3.15 3.184c1.318.802 2.71 1.203 4.178 1.203 1.466 0 2.859-.4 4.177-1.198a9.023 9.023 0 0 0 3.15-3.189c.111-.201.167-.4.167-.597 0-.196-.056-.395-.167-.597zM5.7 4.031c.5-.516 1.097-.774 1.794-.774.112 0 .207.04.285.121.078.08.117.179.117.294a.408.408 0 0 1-.401.415c-.48 0-.89.176-1.23.528-.34.352-.51.776-.51 1.272 0 .116-.04.213-.117.294a.38.38 0 0 1-.285.121.38.38 0 0 1-.284-.12.408.408 0 0 1-.117-.295c0-.72.25-1.34.748-1.856zM11.13 9.82a6.718 6.718 0 0 1-3.634 1.052A6.715 6.715 0 0 1 3.86 9.819c-1.118-.7-2.048-1.642-2.79-2.825.848-1.36 1.91-2.379 3.188-3.054a3.88 3.88 0 0 0-.51 1.947c0 1.067.366 1.98 1.1 2.738.732.759 1.615 1.138 2.647 1.138 1.031 0 1.913-.38 2.647-1.138.733-.758 1.1-1.67 1.1-2.738a3.88 3.88 0 0 0-.51-1.947c1.276.675 2.339 1.693 3.186 3.054-.741 1.183-1.671 2.125-2.79 2.825z',
    fill: '#333',
    fillRule: 'nonzero'
  }));
};

EyeOpen.defaultProps = {
  width: '15',
  height: '14',
  viewBox: '0 0 15 14',
  xmlns: 'http://www.w3.org/2000/svg'
};

var InputField = function (_Component) {
  _inherits(InputField, _Component);

  function InputField() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InputField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputField.__proto__ || Object.getPrototypeOf(InputField)).call.apply(_ref, [this].concat(args))), _this), _this.node = null, _this.state = {
      inputValue: '',
      shownPassword: false,
      active: false
    }, _this.createUUID = function () {
      function s4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0,
              v = c == 'x' ? r : r & 0x3 | 0x8;
          return v.toString(16);
        });
      }
    }, _this.handleChange = function (event) {
      var handleChange = _this.props.handleChange;

      _this.setState({
        inputValue: event.target.value
      });

      handleChange(event);
    }, _this.handleClear = function () {
      var handleClear = _this.props.handleClear;

      _this.setState({
        inputValue: ''
      });

      handleClear();
    }, _this.handleClick = function () {
      var shownPassword = _this.state.shownPassword;

      _this.setState({
        shownPassword: !shownPassword
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InputField, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var value = this.props.value;
      this.setReadOnlyAttribute();

      if (typeof value === 'string') {
        this.setState({
          inputValue: value
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var value = nextProps.value;

      if (typeof value === 'string') {
        this.setState({
          inputValue: value
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.setReadOnlyAttribute();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          cx = _props.cx,
          type = _props.type,
          name = _props.name,
          id = _props.id,
          placeholder = _props.placeholder,
          size = _props.size,
          maxLength = _props.maxLength,
          pattern = _props.pattern,
          isReadOnly = _props.isReadOnly,
          autoComplete = _props.autoComplete,
          headerLabel = _props.headerLabel,
          headerSecondLabel = _props.headerSecondLabel,
          unit = _props.unit,
          search = _props.search,
          step = _props.step;
      var _state = this.state,
          shownPassword = _state.shownPassword,
          inputValue = _state.inputValue,
          active = _state.active;
      var inputType = shownPassword ? 'text' : type;
      return _react2.default.createElement(_react.Fragment, null, _react2.default.createElement('div', {
        className: cx('root', size, {
          filled: inputValue.length > 0,
          hasError: this.hasError(),
          readonly: isReadOnly,
          active: active,
          headerLabel: headerLabel,
          search: search,
          unit: unit,
          notEmptySearch: search && inputValue.length > 0
        })
      }, _react2.default.createElement('div', {
        className: cx('header-label')
      }, headerLabel), _react2.default.createElement('div', {
        className: cx('header-second-label')
      }, headerSecondLabel), _react2.default.createElement('span', {
        className: cx('unit')
      }, unit), search && _react2.default.createElement('span', null, _react2.default.createElement('span', {
        className: cx('search')
      }), inputValue.length > 0 && _react2.default.createElement('div', {
        className: cx('clear'),
        onClick: this.handleClear
      })), _react2.default.createElement('div', {
        className: cx('holder')
      }, _react2.default.createElement('input', {
        type: inputType,
        name: name || this.createUUID(),
        id: id,
        onChange: this.handleChange,
        value: inputValue,
        pattern: pattern,
        autoComplete: autoComplete,
        ref: function ref(node) {
          return _this2.node = node;
        },
        onFocus: function onFocus() {
          return _this2.setState({
            active: true
          });
        },
        onBlur: function onBlur() {
          return _this2.setState({
            active: false
          });
        },
        maxLength: maxLength || 999,
        step: step
      }), _react2.default.createElement('label', {
        htmlFor: id,
        className: cx('label')
      }, placeholder), type === 'password' && this.renderTogglePassword()), this.renderError()));
    }
  }, {
    key: 'setReadOnlyAttribute',
    value: function setReadOnlyAttribute() {
      var isReadOnly = this.props.isReadOnly;

      if (isReadOnly) {
        this.node.setAttribute('readonly', 'readonly');
      } else {
        this.node.removeAttribute('readonly');
      }
    }
  }, {
    key: 'renderError',
    value: function renderError() {
      var _props2 = this.props,
          cx = _props2.cx,
          error = _props2.error;

      if (!error) {
        return null;
      }

      if (Array.isArray(error)) {
        return _react2.default.createElement('div', {
          className: cx('error', {
            shown: this.hasError()
          })
        }, error[0]);
      }

      return _react2.default.createElement('div', {
        className: cx('error', {
          shown: this.hasError()
        })
      }, error);
    }
  }, {
    key: 'hasError',
    value: function hasError() {
      var error = this.props.error;
      return !!error;
    }
  }, {
    key: 'renderTogglePassword',
    value: function renderTogglePassword() {
      var _props3 = this.props,
          cx = _props3.cx,
          isReadOnly = _props3.isReadOnly;
      var shownPassword = this.state.shownPassword;

      if (isReadOnly) {
        return null;
      }

      return _react2.default.createElement('div', {
        className: cx('toggler'),
        onClick: this.handleClick
      }, shownPassword ? _react2.default.createElement(EyeOpen, null) : _react2.default.createElement(EyeClosed, null));
    }
  }]);

  return InputField;
}(_react.Component);

InputField.defaultProps = {
  autoComplete: 'off',
  inputType: 'text',
  handleChange: function handleChange() {},
  handleClear: function handleClear() {},
  isReadOnly: false,
  value: ''
};
InputField.propTypes = {
  id: _propTypes2.default.string,
  name: _propTypes2.default.string.isRequired,
  placeholder: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  pattern: _propTypes2.default.string,
  step: _propTypes2.default.string,
  type: _propTypes2.default.oneOf(['text', 'password', 'number']),
  autoComplete: _propTypes2.default.oneOf(['on', 'off']),
  handleChange: _propTypes2.default.func,
  handleClear: _propTypes2.default.func,
  isReadOnly: _propTypes2.default.bool
};
exports.default = (0, _reactHoc.withStyles)(_InputFieldDefaultModule2.default)(InputField);
module.exports = exports.default;